"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var tokens = exports.tokens = {
  size: {
    xs: {
      width: '320px'
    },
    s: {
      width: '480px'
    },
    m: {
      width: '640px'
    },
    l: {
      width: '768px'
    },
    xl: {
      width: '960px',
      height: '700px'
    },
    xxl: {
      // Do not use without the review of breakpoints for screens smaller than 1158 with the designer
      width: '1158px'
    }
  }
};